import '../css/404.css'

function Error404() {
    return (
  
        <div className='error'>
            <p> 404 <br/> Not Found </p>
        </div>
        
    );
}
  
  export default Error404;